import axios from 'axios';
import { APP_SETTINGS } from "../../config";

export function getUserRoles() {
    return axios.get(APP_SETTINGS.API_PATH.USER_ROLES.getAllUserRoles);
}

export function addNewUserRole(userData) {
    return axios.post(APP_SETTINGS.API_PATH.USER_ROLES.addUserRole, userData);
}

export function removeUserRole(userId) {
    return axios.post(APP_SETTINGS.API_PATH.USER_ROLES.removeUserRole, {
        "requestId": userId
    })
}